import styled from 'styled-components';
import { Input as SemanticInput } from 'semantic-ui-react';

import {
  Button as ButtonLayoutComponent, ErrorHandler as ErrorComponent, CenteredLoader, Text as TextLayoutComponent,
} from '@playbookux/playbook-web-core';

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding-top: 40px;
  width: 100%;
`;

export const ErrorHandler = styled(ErrorComponent)``;

export const Loader = styled(CenteredLoader)``;

export const Typography = styled(TextLayoutComponent)`
  font-size: 24px;
  margin-bottom: 15px;
  max-width: 550px;
  text-align: center;
`;

export const DownloadContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  padding: 10px;
  width: 550px;
`;

export const Content = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

export const Image = styled.img`
  height: 90px;
  width: 90px;
`;

export const Button = styled(ButtonLayoutComponent)`
  &.ui.button {
    margin-bottom: 40px;
    margin-top: 20px;
    width: 170px;
  }
`;

export const DownloadApplicationMessage = styled(TextLayoutComponent)`
  font-size: 18px;
  margin-top: 20px;
  text-align: center;
`;

export const DownloadApplicationLink = styled.a``;

export const LinkMessage = styled(TextLayoutComponent)`
  font-size: 18px;
  text-align: center;
`;

export const Input = styled(SemanticInput)`
  margin-top: 20px;
`;

export const CopiedMessage = styled(TextLayoutComponent)`
  font-size: 14px;
`;
